export enum SettingCategory {
    GENERAL = 'general',
    THEATER = 'theater',
    BOOKING = 'booking',
    DISPLAY = 'display',
    EMAIL = 'email',
    PAYMENT = 'payment',
}

export enum SettingType {
    STRING = 'string',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    IMAGE = 'image',
    JSON = 'json',
}

export enum GoogleMapsType {
    IFRAME = 'iframe',
    GOOGLE_MAPS = 'googleMaps',
}

export enum SettingKey {
    DEFAULT_MAX_CAPACITY = 'defaultMaxCapacity',
    DEFAULT_MAX_CHILDREN_CAPACITY = 'defaultMaxChildrenCapacity',
    LIMITED_AVAILABILITY_THRESHOLD = 'limitedAvailabilityThreshold',
    SEND_EMAIL_ON_BOOKING = 'sendEmailOnBooking',
    ENABLE_PAYMENT_CUSTOMER_DETAILS = 'enablePaymentCustomerDetails',
    ENABLE_API_PAYMENT_CONNECTION = 'enableApiPaymentConnection',
    AVAILABLE_SHOW_COLOR = 'availableShowColor',
    ALMOST_FULL_SHOW_COLOR = 'almostFullShowColor',
    FULL_SHOW_COLOR = 'fullShowColor',
    CHILD_TICKET_PRICE = 'childTicketPrice',
    STANDARD_TICKET_PRICE = 'standardTicketPrice',
    VIP_TICKET_PRICE = 'vipTicketPrice',
    VIP_TICKET_CHILD_PRICE = 'vipTicketChildPrice',
    PAGE_CONTENT = 'pageContent',
    VIVA_PAYMENT_CONFIGURATION = 'vivaPaymentConfiguration',
    GMAIL_SMTP_CONFIGURATION = 'gmailSmtpConfiguration',
    VIP_IMAGE_URL = 'vipImageUrl',
    GOOGLE_MAPS_TYPE = 'googleMapsType',
    ADDITIONAL_FEE_PERCENTAGE = 'additionalFeePercentage',
    MAINTENANCE_MODE = 'maintenanceMode',
}

export interface Setting {
    _id?: string;
    setting_key: string | SettingKey;
    setting_value: string | number | boolean;
    description?: string;
    category?: string | SettingCategory;
    setting_type?: string | SettingType;
    setting_created_at?: Date;
    setting_updated_at?: Date;
}

export interface VivaPaymentConfig {
    source_code: string;
    api_url: string;
    auth_url: string;
    payment_url: string;
    client_id: string;
    client_secret: string;
    default_payment_method_code: string;
    checkout_color: string;
    viva_connect_url: string;
    viva_create_orders_url: string;
    viva_web_checkout_url: string;
    viva_api_orders_url: string;
    merchant_id: string;
    api_key: string;
}

export interface VivaPaymentConfigMain {
    demo: VivaPaymentConfig;
    production: VivaPaymentConfig;
    activeConfig: 'demo' | 'production';
}

export interface GmailSmtpConfig {
    service: string;
    secure: boolean;
    smtp_from: string;
    theater_email: string;
    auth: {
        user: string;
        pass: string;
    }
}